import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { GlobalProvider } from "./contexts/GlobalContext";

import "swiper/css/bundle";
import "./styles/global.scss";

ReactDOM.render(
  <React.StrictMode>
    <GlobalProvider>
      <App />
    </GlobalProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
